import React from "react";
import AsyncSelect from "react-select/async";
import { Typography, Box } from "@mui/material";

function SupplierSelect({ value, onChange, loadOptions, placeholder = "Select supplier..." }) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" mb={0.5}>
        Supplier
      </Typography>
      <AsyncSelect
        cacheOptions
        defaultOptions
        value={value}
        onChange={onChange}
        loadOptions={loadOptions}
        placeholder={placeholder}
        isClearable
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: 8,
            minHeight: 40,
            fontSize: 15,
            borderColor: "#b0b6c7",
            boxShadow: "none",
          }),
          menu: (base) => ({
            ...base,
            borderRadius: 8,
            fontSize: 15,
            zIndex: 20,
          }),
        }}
        getOptionLabel={opt => opt.label || opt.Name}
        getOptionValue={opt => opt.value || opt.Id}
      />
    </Box>
  );
}

export default SupplierSelect;